const img = require('./merit-smile-transparent.png'); export default img;